// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__yIYoM","title":"CardHeader_title__Ac3a1"};